if (!customElements.get("pickup-availability")) {
  customElements.define(
    "pickup-availability",
    class PickupAvailability extends HTMLElement {
      constructor() {
        super();

        this.task = null;
        this.variants_inventory = null;
        subscribe("update-variants-inventory", ({ data: { variantsInventory } }) => {
          this.variants_inventory = variantsInventory;
          if (this.task) {
            this.fetchAvailability(...this.task);
          }
        });

        if (!this.hasAttribute("available")) {
          this.innerHTML = "";
          return;
        }

        this.errorHtml = this.querySelector("template").content.firstElementChild.cloneNode(true);
        this.onClickRefreshList = this.onClickRefreshList.bind(this);
        this.fetchAvailability(this.dataset.variantId, true);
      }

      fetchAvailability(variantId, init = false) {
        if (!variantId) return;

        // 判断是否有库存数据，如果没有则将任务存储起来，等有库存数据后再执行
        if (!this.variants_inventory) {
          // 只缓存最近一次的请求任务
          this.task = arguments;
        }

        this.task = null;

        // 如果当前库存为0，则直接隐藏
        if (this.variants_inventory?.[`gid://shopify/ProductVariant/${variantId}`]?.currentStoreAvailability == 0) {
          this.innerHTML = "";
          return;
        }

        let rootUrl = this.dataset.rootUrl;
        if (!rootUrl.endsWith("/")) {
          rootUrl = rootUrl + "/";
        }
        const variantSectionUrl = `${rootUrl}variants/${variantId}/?section_id=pickup-availability`;

        // 发送请求前将渲染骨架屏
        !init && this.renderSkeleton();
        fetch(variantSectionUrl)
          .then((response) => response.text())
          .then((text) => {
            const sectionInnerHTML = new DOMParser()
              .parseFromString(text, "text/html")
              .querySelector(".shopify-section");
            this.renderPreview(sectionInnerHTML);
          })
          .catch((e) => {
            const button = this.querySelector("button");
            if (button) button.removeEventListener("click", this.onClickRefreshList);
            this.renderError();
          });
      }

      renderSkeleton() {
        this.innerHTML = `
          <div class="skeleton" style="padding: 1rem 0 0 3rem;">
            <div class="skeleton-text" style="--width: 300px;height: 16px;"></div>
            <div class="skeleton-text" style="--width: 350px;height: 16px;"></div>
            <div class="skeleton-text" style="--width: 350px;height: 16px;"></div>
          </div>
        `;
      }

      onClickRefreshList() {
        this.fetchAvailability(this.dataset.variantId);
      }

      update(variant) {
        if (variant?.available) {
          this.fetchAvailability(variant.id);
        } else {
          this.removeAttribute("available");
          this.innerHTML = "";
        }
      }

      renderError() {
        this.innerHTML = "";
        this.appendChild(this.errorHtml);

        this.querySelector("button").addEventListener("click", this.onClickRefreshList);
      }

      renderPreview(sectionInnerHTML) {
        const drawer = document.querySelector("pickup-availability-drawer");
        if (drawer) {
          drawer.classList.add("hidden");
          drawer.remove();
        }
        if (!sectionInnerHTML.querySelector("pickup-availability-preview")) {
          this.innerHTML = "";
          this.removeAttribute("available");
          return;
        }

        this.innerHTML = sectionInnerHTML.querySelector("pickup-availability-preview").outerHTML;
        this.setAttribute("available", "");
        sectionInnerHTML.querySelector("pickup-availability-drawer").classList.add("hidden");
        document.body.appendChild(sectionInnerHTML.querySelector("pickup-availability-drawer"));
        const colorClassesToApply = this.dataset.productPageColorScheme.split(" ");
        colorClassesToApply.forEach((colorClass) => {
          document.querySelector("pickup-availability-drawer").classList.add(colorClass);
        });

        const button = this.querySelector("button");
        const isHide = this.closest(".product-inventory-info")
          ?.querySelector("inventory-info")
          ?.classList?.contains("pickup-availability-hide");

        if (button && !isHide)
          button.addEventListener("click", (evt) => {
            document.querySelector("pickup-availability-drawer").show(evt.target);
          });
      }
    }
  );
}

if (!customElements.get("pickup-availability-drawer")) {
  customElements.define(
    "pickup-availability-drawer",
    class PickupAvailabilityDrawer extends HTMLElement {
      constructor() {
        super();

        this.onBodyClick = this.handleBodyClick.bind(this);

        this.querySelector("button").addEventListener("click", () => {
          this.hide();
        });

        this.addEventListener("keyup", (event) => {
          if (event.code.toUpperCase() === "ESCAPE") this.hide();
        });

        this.business_hours = this.getBusinessHours();

        if (this.business_hours) {
          this.renderBusinessHours();
        }
      }

      weeks = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

      danish = {
        Sunday: "Søn",
        Monday: "Man",
        Tuesday: "Tir",
        Wednesday: "Ons",
        Thursday: "Tor",
        Friday: "Fre",
        Saturday: "Lør",
      };

      renderBusinessHours() {
        const pickup_availability_items = this.querySelectorAll(".pickup-availability-list__item");
        pickup_availability_items?.forEach((item) => {
          const pickup_name = item.querySelector("h3")?.textContent;
          if (this.business_hours[pickup_name]) {
            const business_hours = this.business_hours[pickup_name];
            const today = business_hours[this.weeks[new Date().getDay()]];
            const html = `<details>
              <summary class="today">
                <div><span class="active">Dagens</span> åbningstider ${today}</div>
                <span class="svg-icon" data-icon="ArrowHeadDown" aria-hidden="true"><svg viewBox="0 0 16 9"><path d="M14.29.29A.996.996 0 1 1 15.7 1.7l-7 7a.996.996 0 0 1-1.41 0l-7-7A.996.996 0 1 1 1.7.29L8 6.59z"></path></svg></span>
              </summary>
              <p class="business_hours-label">Åbningstider</p>
              <div class="business_hours-details">
                ${Object.keys(business_hours)
                  .map((week) => {
                    return `
                      <div class="business_hours-item">
                        <span class="business_hours-week">${this.danish[week]}</span>
                        <span class="business_hours-time">${business_hours[week]}</span>
                      </div>
                    `;
                  })
                  .join("")}
              </div>
            </details>`;
            item.querySelector(".business-hours").innerHTML = html;
            item.querySelector(".business-hours").classList.remove("hidden");
          }
        });
      }

      getBusinessHours() {
        return JSON.parse(this.querySelector("[data-business-hours]")?.innerHTML || null);
      }

      handleBodyClick(evt) {
        const target = evt.target;
        if (
          target != this &&
          !target.closest("pickup-availability-drawer") &&
          target.id != "ShowPickupAvailabilityDrawer"
        ) {
          this.hide();
        }
      }

      hide() {
        this.removeAttribute("open");
        document.body.removeEventListener("click", this.onBodyClick);
        document.body.classList.remove("overflow-hidden");
        removeTrapFocus(this.focusElement);
      }

      show(focusElement) {
        this.classList.remove("hidden");
        this.focusElement = focusElement;
        this.setAttribute("open", "");
        document.body.addEventListener("click", this.onBodyClick);
        document.body.classList.add("overflow-hidden");
        trapFocus(this);
      }
    }
  );
}
